import { getUuid } from "./../utils/utils";
import { Log } from "utils";
import { getStoreData, getStoreToken } from "utils/storage";
import { urlApp } from "constants/AppUrl";
import { doPostAxios } from "./axios";
// import RNFetchBlob from "rn-fetch-blob";

const baseURL = __DEV__ ? urlApp.APIURL : urlApp.APIURL;

export function uploadFile(params: { fileBase64: string }) {
  return new Promise(async (rs, rj) => {
    try {
      if (!params.fileBase64) {
        rj("Error!");
      }
      const r = await doPostAxios(`upload/base64`, {
        fileBase64: params.fileBase64.replace("data:image/png;base64,", ""),
      });
      if (r?.status == 200 && r?.data) {
        const mToken = await getStoreToken();
        const url = r.data;
        const imgUrl = `${urlApp.APIURL}/api/download/file-for-link?token=${mToken}&uri=${url}`;

        rs(imgUrl);
      }
      rj(r);
    } catch (error) {
      Log("uploadFile error", error);
      rj(error);
    }
  });
}
